// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {SimEnumExtendedService, NotificationService, SimTrainingRoomService} from "@services";
import {Camera, TrainingRoom, WebCameraView} from "@models";
import {Translations} from "@translations";

export interface DialogData_CameraSelectionDialogInput extends MatDialogDataBaseInput {
	cameras: Camera[];
	trainingRoom: TrainingRoom;
}

export interface DialogData_CameraSelectionDialogOutput extends MatDialogDataBaseOutput {
	updatedTrainingRoom: TrainingRoom;
}

@Component({
	selector: "sim-camera-selection-dialog",
	templateUrl: "./camera-selection-dialog.component.html",
	styleUrls: ["./camera-selection-dialog.component.scss"],
	standalone: false,
})
export class CameraSelectionDialogComponent extends BasicMaterialDialog<
	CameraSelectionDialogComponent,
	DialogData_CameraSelectionDialogInput,
	DialogData_CameraSelectionDialogOutput
> {
	T = Translations;
	public cameraPositions: {cameraId: string; position: number}[] = null;

	public selectedCameraId: string = null;

	public unassignedCameras: Camera[] = null;

	constructor(
		_injector: Injector,
		private _simEnumService: SimEnumExtendedService,
		private _simTrainingRoomService: SimTrainingRoomService,
		private _simNotificationService: NotificationService,
	) {
		super(_injector);
	}

	public ngOnInit() {
		this.updateUnassignedCameras();
	}

	ok() {
		this.selectedCameraId = null;
		this.unassignedCameras = null;
		this.close({action: "ok", updatedTrainingRoom: this.data.trainingRoom});
	}

	private updateUnassignedCameras() {
		if (this.data.cameras && this.data.trainingRoom) {
			this.unassignedCameras = this.data.cameras.filter((camera) => !this.data.trainingRoom.availableCameraIds.includes(camera.id));
		}
	}

	public addCamera(cameraId: string, cameraIds: string[]) {
		if (cameraIds.indexOf(cameraId) < 0) {
			cameraIds.push(cameraId);
			this.updateUnassignedCameras();
		}
	}

	public removeCamera(cameraId: string) {
		this.data.trainingRoom.availableCameraIds.splice(this.data.trainingRoom.availableCameraIds.indexOf(cameraId), 1);
		this.updateUnassignedCameras();
	}

	public getCameraName(cameraId: string) {
		const match = this.data?.cameras.find((camera) => camera.id === cameraId);
		if (match) {
			return match.name;
		} else {
			return `Camera not defined: ${cameraId}`;
		}
	}

	public cameraSelectionChanged(event: any) {
		this.addCamera(this.selectedCameraId, this.data.trainingRoom.availableCameraIds);
	}
}
